/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=6820eeb1&scoped=true"
import script from "./TheFooter.ts?vue&type=script&lang=ts&external"
export * from "./TheFooter.ts?vue&type=script&lang=ts&external"
import style0 from "./TheFooter.vue?vue&type=style&index=0&id=6820eeb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6820eeb1",
  null
  
)

export default component.exports